<template>
  <v-dialog v-model="active" width="560">
    <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
      <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Detalle de asignación</v-card-title>
      <v-card-text v-if="asignacion" class="pt-4">
        <v-row dense>
          <v-col cols="12" sm="6">
            <div class="detalle-label">Fecha de solicitud</div>
            <div class="detalle-valor">{{ formatearFecha(asignacion.fechaSolicitud) }}</div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="detalle-label">Fecha de asignación</div>
            <div class="detalle-valor">{{ formatearFecha(asignacion.fechaAsignacion) }}</div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="detalle-label">Folio de resguardo</div>
            <div class="detalle-valor">{{ asignacion.folioResguardo || '—' }}</div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="detalle-label">Adjunto</div>
            <div class="detalle-valor">
              <a v-if="asignacion.urlAdjunto" :href="asignacion.urlAdjunto" target="_blank" rel="noopener">
                {{ asignacion.evidencia || 'Ver adjunto' }}
              </a>
              <span v-else>—</span>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="detalle-label">Observaciones</div>
            <div class="detalle-valor">{{ asignacion.observaciones || '—' }}</div>
          </v-col>
          <v-col cols="12">
            <div class="detalle-label mb-2">Equipos asignados</div>
            <v-data-table
              :headers="equipoHeaders"
              :items="asignacion.equipoAsignado || []"
              class="ui-module-table"
              hide-default-footer
              disable-pagination
              no-data-text="Sin equipos asignados."
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center pb-4 ui-module-actions">
        <v-btn text class="ui-module-btn-text-danger mx-8" @click="$emit('close')">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    asignacion: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      equipoHeaders: [
        { text: 'Equipo', value: 'equipo' },
        { text: 'Número', value: 'numero' },
      ],
    }
  },

  methods: {
    formatearFecha(valor) {
      if (!valor) return '—'
      const d = new Date(valor)
      return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
  },
}
</script>

<style scoped>
.detalle-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(224, 224, 224, 0.6);
}

.detalle-valor {
  font-size: 0.95rem;
  color: #e0e0e0;
  margin-bottom: 12px;
}
</style>
